// extracted by mini-css-extract-plugin
export default {"container":"ExpandableText_container__uTCeo","content":"ExpandableText_content__wVJjY","expandToggle":"ExpandableText_expandToggle__V4qeM"};